import loc from 'owa-localize';
import { PersonaPresence } from 'office-ui-fabric-react/lib/Persona';
import InstantMessagePresenceType from 'owa-service/lib/contract/InstantMessagePresenceType';
import { OwaPresence } from '../../store/schema/OwaPresence';
import {
    ucmaAway,
    ucmaOffline,
    ucmaBusy,
    ucmaDoNotDisturb,
    ucmaOnline,
    ucmaSignInToIM,
} from '../../strings.locstring.json';

const SWC_CDN_PREFIX = 'https://swc.cdn.skype.com/assets/personas/status/';

export function getOwaPresenceFromInstantMessagePresenceType(
    serverPresence: InstantMessagePresenceType
): OwaPresence {
    switch (serverPresence) {
        case 'Offline':
            return {
                key: serverPresence,
                personaPresence: PersonaPresence.offline,
                description: loc(ucmaOffline),
                url: SWC_CDN_PREFIX + 'Offline.svg',
            };
        case 'Away':
        case 'BeRightBack':
            return {
                key: serverPresence,
                personaPresence: PersonaPresence.away,
                description: loc(ucmaAway),
                url: SWC_CDN_PREFIX + 'Away.svg',
            };
        case 'Busy':
        case 'IdleBusy':
            return {
                key: serverPresence,
                personaPresence: PersonaPresence.busy,
                description: loc(ucmaBusy),
                url: SWC_CDN_PREFIX + 'Busy.svg',
            };
        case 'DoNotDisturb':
            return {
                key: serverPresence,
                personaPresence: PersonaPresence.dnd,
                description: loc(ucmaDoNotDisturb),
                url: SWC_CDN_PREFIX + 'DoNotDisturb.svg',
            };
        case 'Online':
        case 'IdleOnline':
            return {
                key: serverPresence,
                personaPresence: PersonaPresence.online,
                description: loc(ucmaOnline),
                url: SWC_CDN_PREFIX + 'Available.svg',
            };
        case 'None':
            return {
                key: serverPresence,
                personaPresence: PersonaPresence.none,
                description: '',
                url: SWC_CDN_PREFIX + 'Unknown.svg',
            };
    }
}

export const DefaultMeCardPresences = [
    getOwaPresenceFromInstantMessagePresenceType('Online'),
    getOwaPresenceFromInstantMessagePresenceType('Away'),
    getOwaPresenceFromInstantMessagePresenceType('Busy'),
    getOwaPresenceFromInstantMessagePresenceType('DoNotDisturb'),
    getOwaPresenceFromInstantMessagePresenceType('Offline'),
];

export const SignInToIM: OwaPresence = {
    key: 'Online',
    personaPresence: PersonaPresence.online,
    description: loc(ucmaSignInToIM),
    url: SWC_CDN_PREFIX + 'Unknown.svg',
};
